import { CardHeaderBody } from "./card-header-body";

export class LineSeries {
    seriesDetails: CardHeaderBody[];

    constructor(seriesDetails: CardHeaderBody[]) {
        this.seriesDetails = seriesDetails

    }
}